export default __webpack_public_path__ + "static/media/download-pdf.1db458f0.svg";